import { render, staticRenderFns } from "./CollectionDescription.vue?vue&type=template&id=c904da2c&scoped=true&"
import script from "./CollectionDescription.vue?vue&type=script&lang=js&"
export * from "./CollectionDescription.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDescription.vue?vue&type=style&index=0&id=c904da2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c904da2c",
  null
  
)

export default component.exports